class OrderItemRepeater extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector('[data-item-row-template]');
    this.rows = this.querySelector('[data-item-rows]');
    this.addButton = this.querySelector('[data-add-item]');

    if (!this.template || !this.rows || !this.addButton) return;

    this.counter = this.rows.querySelectorAll('[data-item-row]').length;

    this.addButton.addEventListener('click', () => this.addRow());
    this.rows.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-item]');
      if (!removeButton) return;

      removeButton.closest('[data-item-row]')?.remove();
    });

    this.closest('form')?.addEventListener('submit', () => this.normalizeRows());
  }

  normalizeRows() {
    let index = 0;

    this.rows.querySelectorAll('[data-item-row]').forEach((row) => {
      const sku = row.querySelector('[name*="SKU"]');
      const quantity = row.querySelector('[name*="Quantity"]');
      const hasValue = (sku && sku.value.trim() !== '') || (quantity && quantity.value.trim() !== '');

      if (!hasValue) {
        if (sku) sku.disabled = true;
        if (quantity) quantity.disabled = true;
        return;
      }

      index += 1;
      if (sku) sku.name = `contact[Item ${index} SKU]`;
      if (quantity) quantity.name = `contact[Item ${index} Quantity]`;
    });
  }

  addRow() {
    this.counter += 1;

    const fragment = this.template.content.cloneNode(true);

    fragment.querySelectorAll('[id], [for], [name]').forEach((element) => {
      ['id', 'for', 'name'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value) element.setAttribute(attribute, value.replace(/__INDEX__/g, String(this.counter)));
      });
    });

    this.rows.appendChild(fragment);
  }
}

if (!customElements.get('order-item-repeater')) {
  customElements.define('order-item-repeater', OrderItemRepeater);
}
